<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data">
      <template #suffix>
        <b-button variant="success" @click="exportDividendReport()">匯出Excel</b-button>
      </template>
    </bread-crumb>

    <div class="operate">
      <div class="search">
        <date-picker
          v-model="search.join_date_S"
          :position="'right'"
          placeholder="入會日期開始"
        ></date-picker>

        <date-picker
          v-model="search.join_date_E"
          :position="'right'"
          placeholder="入會日期結束"
        ></date-picker>
      </div>

      <b-button variant="success" @click="getMember(1)">搜尋</b-button>
    </div>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
      :pageData="data.page"
      v-on:result="getMember"
    >
      <template #cell(status)="row">
        {{ getRightsInterests(row.item.status).text }}
      </template>

      <template #cell(join_date)="row">
        {{ convertRocDate(row.item.join_date, false) }}
      </template>

      <template #cell(first_payment_at)="row">
        {{ convertRocDate(row.item.first_payment_at, false) }}
      </template>

      <template #cell(second_payment_at)="row">
        {{ convertRocDate(row.item.second_payment_at, false) }}
      </template>

      <template #cell(third_payment_at)="row">
        {{ convertRocDate(row.item.third_payment_at, false) }}
      </template>

      <template #cell(dead_at)="row">
        {{ convertRocDate(row.item.dead_at, false) }}
      </template>

      <template #cell(re_sales)="row">
        <template v-if="row.item.children && row.item.children.length > 0 && row.item.first_return === 1">
          {{ row.item.children[0].number }}
        </template>
      </template>

      <template #cell(re_name)="row">
        <template v-if="row.item.children && row.item.children.length > 0 && row.item.first_return === 1">
          {{ row.item.children[0].name }}
        </template>
      </template>

      <template #cell(claim_recommend)="row">
        {{ Number(row.item.claim_recommend) === 1 ? '是' : '否' }}
      </template>
    </tables-page>

  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from '@/components/layouts/TablesPage';
import datePicker from '@/components/common/DatePicker';
import contractApi from '@/models/API/contractApi';
import { convertRocDate, downloadFile, getFirstAndLastDayOfMonth, getRightsInterests } from '@/models/HELPERS/common.js';

const currentMonth = getFirstAndLastDayOfMonth();

export default {
  name: 'monthlyDividendReport',
  components: {
    BreadCrumb,
    TablesPage,
    datePicker
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '每月分紅制度報表', url: '', isActive: false }
        ]
      },
      search: {
        join_date_S: currentMonth.first_day,
        join_date_E: currentMonth.last_day
      },
      data: {
        page: {},
        table_data: [],
        table_fields: [
          {
            key: 'no',
            label: 'No'
          },
          {
            key: 'sales_number',
            label: '業務編號'
          },
          {
            key: 'sales_name',
            label: '業務姓名'
          },
          {
            key: 'sales_rank',
            label: '聘階'
          },
          {
            key: 'status',
            label: '權益'
          },
          {
            key: 'number',
            label: '契約編號'
          },
          {
            key: 'join_date',
            label: '入會日期'
          },
          {
            key: 'member_name',
            label: '互助人'
          },
          {
            key: 'pay_name',
            label: '要助人'
          },
          {
            key: 'sales_manager',
            label: '經理姓名'
          },
          {
            key: 'sales_reserve',
            label: '儲總姓名'
          },
          {
            key: 'sales_director',
            label: '總監姓名'
          },
          {
            key: 'first_payment_at',
            label: '第一次繳款日'
          },
          {
            key: 'second_payment_at',
            label: '第二次繳款日'
          },
          {
            key: 'third_payment_at',
            label: '第三次繳款日'
          },
          {
            key: 'dead_at',
            label: '身故日期'
          },
          {
            key: 're_sales',
            label: '上歸業務'
          },
          {
            key: 're_name',
            label: '上歸姓名'
          },
          {
            key: 'sales_lecturer',
            label: '講師資格'
          },
          {
            key: 'claim_recommend',
            label: '禮儀服務'
          }
        ]
      }
    }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    load() {
      this.data.page = Object.assign({}, this.contractApi.page);
      this.getMember();
    },
    convertRocDate,
    getRightsInterests,
    // 匯出分紅制度報表EXCEL
    exportDividendReport() {
      this.contractApi.exportDividendReport((response) => {
        if (!response) return;

        downloadFile(response);
      }, this.search)
    },
    // 查詢指定入會日期區間的契約
    getMember(pageIndex = null) {
      const params = {
        'join_date_S': this.search.join_date_S,
        'join_date_E': this.search.join_date_E,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex
      };

      this.contractApi.getMember((response) => {
        const res = response.data;
        const currentPageIndex = pageIndex ? pageIndex : this.data.page.pageIndex;

        this.data.page.totalCount = res.total;
        this.data.table_data = res.data.map((item, index) => {
          return {
            ...item,
            no: (currentPageIndex - 1) * this.data.page.pageSize + index + 1
          }
        });
      }, params)
    }
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;

  .search {
    display: grid;
    grid-template-columns: repeat(2, minmax(220px, 280px));
    gap: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/monthlyDividendReport.vue